import React from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { FormGroup, FormControl, FormLabel, Row, Col } from "react-bootstrap";
import { IoMdColorFill } from "react-icons/io";
import { FiDelete } from "react-icons/fi";
import { paymentTypesService } from "services";
import { errorFormating } from "utils/utils";
import SubmitButton from "components/SubmitButton";
import Switch from "components/Switch";
import { TwitterPicker } from "react-color";
import * as expensesActions from "actions/expensesActions";

class PaymentTypeEdit extends React.Component {
	constructor(props) {
		super(props);

		let payment_type = {
			name: "",
			description: "",
			background_color: "",
			border_color: "",
			enabled: true,
		};

		let isEdit = false;

		if (props.payment_type) {
			payment_type = props.payment_type;
			isEdit = true;
		}

		this.state = {
			isEdit,
			isLoading: false,
			submitted: false,
			errors: {},
			payment_type,
			isBorderPickerVisible: false,
			isBackgroundPickerVisible: false,
		};
	}

	handleChange = (event) => {
		const { payment_type } = this.state;

		this.setState({
			payment_type: {
				...payment_type,
				[event.target.id]: event.target.value,
			},
		});
	};

	handleColorChange = ({ hex }, type) => {
		const { payment_type } = this.state;

		if (hex === undefined) hex = "";

		this.setState({
			payment_type: {
				...payment_type,
				[type]: hex,
			},
			isBackgroundPickerVisible: false,
			isBorderPickerVisible: false,
		});
	};

	handleSwitch = (event) => {
		const { payment_type } = this.state;

		this.setState({
			payment_type: {
				...payment_type,
				[event.target.id]: event.target.checked,
			},
		});
	};

	checkValidField = (name) => {
		return (
			this.state.submitted &&
			this.state.errors[name] !== undefined &&
			this.state.errors[name] !== ""
		);
	};

	handleSubmit = async (event) => {
		event.preventDefault();

		this.setState({ isLoading: true });
		let response = "";
		const props = this.props;

		if (this.state.isEdit) {
			response = await paymentTypesService.update(this.state.payment_type);
		} else {
			response = await paymentTypesService.add(this.state.payment_type);
		}

		if (response.ok) {
			this.setState(
				{
					isLoading: false,
					errors: {},
				},
				() => {
					toastr.success(this.props.t("common.success"), this.props.t("common.changesSaved"));
					this.props.getPaymentTypes();
					props.handleClose();
				}
			);
		} else {
			this.setState({
				isLoading: false,
				submitted: true,
				errors: errorFormating(response),
			});
		}
	};

	render() {
		const { t } = this.props;
		const { payment_type, errors } = this.state;

		const onToggleBackgroundPicker = () =>
			this.setState({
				isBackgroundPickerVisible: !this.state.isBackgroundPickerVisible,
			});
		const onToggleBorderPicker = () =>
			this.setState({
				isBorderPickerVisible: !this.state.isBorderPickerVisible,
			});

		return (
			<form onSubmit={this.handleSubmit}>
				<div className="modal-body">
					<FormGroup className="form-group" controlId="name">
						<FormLabel>
							{t("common.name")} <span className="label-required">*</span>
						</FormLabel>
						<FormControl
							type="text"
							value={payment_type.name}
							onChange={this.handleChange}
							placeholder={t("paymentTypes.namePlaceholder")}
							isInvalid={this.checkValidField("name")}
						/>
						<FormControl.Feedback type="invalid">
							{this.state.errors.name}
						</FormControl.Feedback>
					</FormGroup>

					<FormGroup className="form-group" controlId="description">
						<FormLabel>{t("common.description")}</FormLabel>
						<FormControl
							as="textarea"
							value={payment_type.description}
							onChange={this.handleChange}
							placeholder={t("paymentTypes.descriptionPlaceholder")}
							isInvalid={this.checkValidField("description")}
						/>
						<FormControl.Feedback type="invalid">
							{this.state.errors.description}
						</FormControl.Feedback>
					</FormGroup>

					<Row>
						<Col sm={6}>
							<FormGroup
								controlId="background_color"
								className="form-group form-color"
							>
								<div className="flex-between">
									<FormLabel>{t("common.backgroundColor")}</FormLabel>
									<FiDelete
										className={`icon-remove-color ${!payment_type.background_color && "hidden"}`}
										onClick={() => this.handleColorChange({ hex: "" }, "background_color")}
									/>
								</div>
								<FormControl
									type="text"
									value={payment_type.background_color}
									placeholder="#FFFFFF"
									readOnly
									isInvalid={this.checkValidField("background_color")}
									style={{
										backgroundColor: payment_type.background_color || undefined,
									}}
									onClick={onToggleBackgroundPicker}
								/>
								<FormControl.Feedback type="invalid">
									{errors.background_color}
								</FormControl.Feedback>
								<IoMdColorFill onClick={onToggleBackgroundPicker} />
								{this.state.isBackgroundPickerVisible && (
									<div style={{ position: "absolute" }}>
										<TwitterPicker
											color={payment_type.background_color || "#ffffff"}
											onChangeComplete={(hex) =>
												this.handleColorChange(hex, "background_color")
											}
										/>
									</div>
								)}
							</FormGroup>
						</Col>
						<Col sm={6}>
							<FormGroup
								controlId="border_color"
								className="form-group form-color"
							>
								<div className="flex-between">
									<FormLabel>{t("common.borderColor")}</FormLabel>
									<FiDelete
										className={`icon-remove-color ${!payment_type.border_color && "hidden"}`}
										onClick={() => this.handleColorChange({ hex: "" }, "border_color")}
									/>
								</div>
								<FormControl
									type="text"
									value={payment_type.border_color}
									placeholder="#FFFFFF"
									readOnly
									isInvalid={this.checkValidField("border_color")}
									style={{
										backgroundColor: payment_type.border_color || undefined,
									}}
									onClick={onToggleBorderPicker}
								/>
								<FormControl.Feedback type="invalid">
									{errors.border_color}
								</FormControl.Feedback>
								<IoMdColorFill onClick={onToggleBorderPicker} />
								{this.state.isBorderPickerVisible && (
									<div style={{ position: "absolute" }}>
										<TwitterPicker
											color={payment_type.border_color || "#ffffff"}
											onChangeComplete={(hex) =>
												this.handleColorChange(hex, "border_color")
											}
										/>
									</div>
								)}
							</FormGroup>
						</Col>
					</Row>

					<FormGroup
						className="form-group form-group-flex mb0"
						controlId="enabled"
					>
						<FormLabel>{t("common.active")}</FormLabel>
						<Switch
							controlId="enabled"
							isOn={payment_type.enabled}
							handleToggle={this.handleSwitch}
						/>
						<FormControl.Feedback type="invalid">
							{this.state.errors.enabled}
						</FormControl.Feedback>
					</FormGroup>
				</div>

				<div className="modal-footer">
					<button
						type="button"
						onClick={this.props.handleClose}
						className="btn btn-outline-primary"
					>
						{t("common.cancel")}
					</button>
					<SubmitButton
						type="submit"
						isLoading={this.state.isLoading}
						text={t("common.save")}
						loadingText={t("common.saving")}
					/>
				</div>
			</form>
		);
	}
}

const mapStateToProps = (reducers) => {
	return reducers.expensesReducer;
};

export default connect(mapStateToProps, expensesActions)(withTranslation()(PaymentTypeEdit));
